import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    class: "aside-menu",
    router: "",
    "collapse-transition": "",
    "background-color": "rgb(48, 65, 86)",
    "text-color": "white"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsMenu, (item, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
          (item.children?.length)
            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                index: item.url
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemChild, idxChild) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: idxChild,
                      index: itemChild.url
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(itemChild.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["index"]))
            : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: idx,
                index: item.url
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}